<template>
  <Purchase :product="product" :startPurchase="pay" v-if="product">
    <template v-slot:header>
      <PurchasePersonDetails
        :product="product"
        :person="productToBuy.details"
      />
    </template>
  </Purchase>
</template>

<script>
import { mapActions } from 'vuex';
import Purchase from './Purchase';
import PurchasePersonDetails from './PurchasePersonDetails';

export default {
  props: ['product', 'productToBuy'],
  components: {
    Purchase,
    PurchasePersonDetails,
  },
  methods: {
    ...mapActions('purchase', ['buyReport']),

    pay(details) {
      const params = {
        ...details,
        productCode: this.product.productCode,
        personId: this.productToBuy.details.personId,
      };

      return this.buyReport(params);
    },
  },
};
</script>
